import { ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ClaimRow } from '../../../../models/api/view/claim-view/claim-row';
import { AllocationDetails } from '../../../../models/api/view/claim/financials/payment-history/payment-allocation-details';
import { BaseComponent } from '../../../base/base.component';
import { DetailItemComponent } from '../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../core/panels/detail-panel/detail-panel.component';
import { ColumnComponent } from '../../../core/table/column.component';
import { TableComponent } from '../../../core/table/table.component';

@Component({
  selector: 'app-payment-allocation-detail',
  imports: [
    DetailPanelComponent,
    DetailItemComponent,
    RouterModule,
    TableComponent,
    ColumnComponent,
  ],
  template: ` <div class="tw-pb-4 tw-pt-6 tw-grow">
      <div class="tw-flex tw-gap-8">
        <div class="tw-basis-1/3">
          <app-detail-panel [dataSource]="allocationDetail">
            <app-detail-item label="Allocation" name="allocNum" />
            <app-detail-item label="Pay code" name="payCode" />
            <app-detail-item label="Earnings code" name="earnCode" />
            <app-detail-item label="Payment amount" name="amount" format="c" />
            <app-detail-item label="Postmark" name="datePostmrkd" format="d" />
          </app-detail-panel>
        </div>
        <div class="tw-basis-1/3">
          <app-detail-panel [dataSource]="allocationDetail">
            <app-detail-item label="Pay from" name="datePayFrom" format="d" />
            <app-detail-item
              label="Pay through"
              name="datePayThru"
              format="d"
            />
            <app-detail-item label="Lost work days" name="lostWorkDays" />
            <app-detail-item
              label="Received date"
              name="dateBilled"
              format="d"
            />
            <app-detail-item label="Invoice" name="binVoice" />
          </app-detail-panel>
        </div>
        <div class="tw-basis-1/3">
          <app-detail-panel [dataSource]="allocationDetail">
            <app-detail-item
              label="Amount billed"
              name="billedAmt"
              format="c"
            />
            <app-detail-item label="Vendor" name="vendorId" />
            @if (this.disability) {
              <app-detail-item label="Internal control number" name="icn" />
            } @else if (canAccessDetailLinks) {
              <app-detail-item label="Internal control number">
                <ng-template #value let-data>
                  <a
                    class="tw-text-[var(--sed-link-color)] tw-underline"
                    [routerLink]="['../invoice-bill', data.icn]"
                    [queryParams]="{
                      backLabel: 'Payment history',
                      backRouterLink: '../payment-history',
                    }"
                    >{{ data.icn }}</a
                  >
                </ng-template>
              </app-detail-item>
            } @else {
              <app-detail-item label="Internal control number" name="icn" />
            }
            <app-detail-item
              label="Reimbursable"
              name="reimburseFlag"
              format="b"
            />
            <app-detail-item label="Reimbursable code" name="reimburseCode" />
          </app-detail-panel>
        </div>
      </div>
      <app-detail-panel
        [dataSource]="allocationDetail"
        labelPosition="Top"
        class=""
      >
        <app-detail-item label="Comment" name="allocComments" />
      </app-detail-panel>
    </div>
    @if (workersComp) {
      <div class="tw-basis-full">
        @if (allocationDetail?.attributes?.length > 0) {
          <app-table
            [dataSource]="allocationDetail.attributes"
            [pageSize]="5"
            [scrollable]="false"
            dataKey="id"
            recordLabel="Attribute"
            [theme]="'Dark'"
          >
            <app-column name="attributeType" label="type" />
            <app-column name="attributeValue" label="value" />
            <app-column name="attributeCategory" label="category" />
            <app-column name="attributeSubCategory" label="Sub category" />
            <app-column name="deleted" label="Deleted" format="b" />
          </app-table>
        }
      </div>
    }`,
  styles: [],
})
export class PaymentAllocationDetailComponent
  extends BaseComponent
  implements OnInit
{
  private cdr = inject(ChangeDetectorRef);

  @Input() allocateUid: any;
  allocationDetail: AllocationDetails;
  disability = false;
  workersComp = false;
  claim: ClaimRow;

  // Security: Check if user can access detail links (BillingFull vs BillingLimited)
  canAccessDetailLinks = false;

  async ngOnInit() {
    this.claim = this.view.currentClaim();
    this.disability = this.claim.lineOfBusiness === 'DS';
    this.workersComp = this.claim.lineOfBusiness === 'WC';

    // Check if user has BillInvoiceDetailLinks token (BillingFull access)
    this.canAccessDetailLinks = this.session.authorize(
      'BillInvoiceDetailLinks',
    );

    this.allocationDetail = await this.api.paymentHistory.getAllocationDetails(
      this.claim.recordSource,
      this.claim.recordId,
      this.allocateUid,
    );
    this.cdr.detectChanges();
  }
}
